// extracted by mini-css-extract-plugin
export default {"deletedAppContainer":"style_deletedAppContainer__0WsGz","headerMain":"style_headerMain__F9Owg","bodyMain":"style_bodyMain__G5UGe","footerMain":"style_footerMain__tEWbv"};